module.exports = __webpack_public_path__ + "static/img/bg1.41475fd8.png";